import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress
} from '@mui/material';
import { fetchSubscriptionFilters } from '../../utils/helper';

const SubscriptionStatusFilter = ({
  value = 'all',
  onChange,
  fullWidth = true,
  size = 'medium'
}) => {
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const backendFilters = await fetchSubscriptionFilters();
        
        // Combine backend filters with "all" option
        const allFilters = [
          { value: 'all', label: 'All Subscriptions' },
          ...backendFilters
        ];
        
        setFilters(allFilters);
      } catch (error) {
        console.error('Error loading subscription filters:', error);
        // Fallback to default filters
        setFilters([
          { value: 'all', label: 'All Subscriptions' },
          { value: 'expired', label: 'Expired' },
          { value: 'expiring_soon', label: 'Expiring Soon (≤7 days)' },
          { value: 'free', label: 'Free Plans' },
          { value: 'basic', label: 'Basic Plans' },
          { value: 'advance', label: 'Advance Plans' }
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadFilters();
  }, []);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} size={size} sx={{ minWidth: 220 }}>
        <InputLabel id="subscription-filter-label">Subscription</InputLabel>
        <Select
          labelId="subscription-filter-label"
          value={value}
          disabled
          label="Subscription"
        >
          <MenuItem value={value}>
            <CircularProgress size={16} sx={{ mr: 1 }} />
            Loading...
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={{ minWidth: 220 }}>
      <InputLabel id="subscription-filter-label">Subscription</InputLabel>
      <Select
        labelId="subscription-filter-label"
        value={value}
        onChange={handleChange}
        label="Subscription"
      >
        {filters.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SubscriptionStatusFilter;
